import React, {memo} from "react";

import { AppBar, Container, Toolbar, Typography } from '@mui/material';
import './nav_bar.scss';

import LogoutIcon from '../../assets/logout.svg'
import ButtonMain from "../button/Button_main";
import ButtonImgMain from "../button/Button_img_main";
import SwitchInput from "../input/Switch_input";

import Trash from '../../assets/trash.svg'


const FooterBar = (props) => {

    return(
            <AppBar position="fixed" className="shadow-none bottom-0 top-auto">
                <Container maxWidth="xl">
                    <Toolbar disableGutters className={`flex ${props.buttonRightDel ||  props.autoEmail ? 'justify-between' : 'justify-end'} items-center py-5`}>
                        { props.buttonRightDel ? (
                            <ButtonImgMain 
                                variant='redOutline' 
                                type='button' 
                                disabled={false} 
                                name={`${props.buttonRightDel}`}
                                class='capitalize mr-3'
                                onClick={()=>props.delAll()}
                                img={Trash}
                            />
                            ):''
                        }
                        {
                            props.autoEmail ? (
                                <div className="mr-5 flex items-center">
                                    <Typography variant="text20" component={'div'} className="mr-3 font-medium">
                                        Email Automation
                                    </Typography>
                                    <SwitchInput
                                        checked={props.switchChecked}
                                        setChecked={props.setSwitchChecked}
                                    />
                                </div>
                            ):''
                        }
                        <div className="text-primary font-sans font-bold text-3xl">
                            { props.btnOutline?(
                                <ButtonMain 
                                    variant='primaryOutline' 
                                    type='button' 
                                    disabled={false} 
                                    name={`${props.btnOutline? props.btnOutline:'Cancel'}`}
                                    class='capitalize mr-3'
                                    onClick={()=>props.cancel()}
                                />
                                ):'' 
                            }
                            <ButtonMain 
                                variant='secondary' 
                                type='submit' 
                                disabled={props.disabledSecondary ? props.disabledSecondary : false} 
                                name={`${props.btnFill? props.btnFill:'Save'}`}
                                class='capitalize'
                                onClick={()=>props.submitBtn()}
                            />
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>
    )
}

export default memo(FooterBar);